import React, { Component } from "react";
import "./style.css";
import "../../../../index.css";
class MajorIntroTop extends Component {
  render() {
    const { marjorName, level } = this.props;
    return (
      <div className="majorIntroTop_box">
        <div className="majorIntroTop_box_left fl">{marjorName}</div>
        <div
          style={{ backgroundColor: level === "本科" ? "#ff9b00" : "#8bbded" }}
          className="majorIntroTop_box_right fl"
        >
          {level}
        </div>
        <div className="clear"></div>
      </div>
    );
  }
}

export default MajorIntroTop;



// WEBPACK FOOTER //
// ./src/containers/MajorIntro/components/MajorIntroTop/index.js